import Config from "../model/Config";
import Provider from "../model/Provider";

var rootId = "";

export const mTransKey = {
    init: ()=>{
        if(Provider.deviceInfo.code == "MO"){
            $("#oacxEmbededContents .mTranceKey-btn.off").css("bottom","16px");
        }
        rootId = Config.appendElementTagId;

        //업무서버 Context Path 지정
        /* transkey_url = Config.url.jsp.contextPath + transkey_url
        transkey_surl = Config.url.jsp.contextPath + transkey_surl
        mtk.initCallback = function(){

        } */
        mTransKey.event();
    },
    close: ()=>{
        if(Config.mTranskey.use){
            if(mtk != null && mtk.now != null){
                mtk.close();
            }
        }
    },
    isMasking: (value)=>{
        return value.match("\\*") != null;
    },
    initSetting: ()=>{
        if(Config.mTranskey.use){
            initmTranskey();
        }
        // use_form_id = true;
        if(Provider.deviceInfo.code == "MO"){
            max_width = 0; //초기 너비값
            widthRatio = 1;
        }else if(Provider.deviceInfo.code == "PC"){
            widthRatio = 0;
            max_width = 300; //초기 너비값
            mTransKey.setmKey_position(); //초기 Position 결정
            //창크기에 따른 Div Position 결정
            window.addEventListener("resize", mTransKey.setmKey_position, false);
        }

        //Style 지정
        mTransKey.style_on();

        if(Config.mTranskey.use){

            //닫기 Function Callback
            mtk.closeCallBack = function(){
                mTransKey.style_off();
                mTransKey.setWithoutSessionDecodeJson();
                // mTransKey.testAjax('mtranskey_pwd');
            }
            //확인버튼 Function Callback
            mtk.doneCallBack = function(){
                mTransKey.style_off();
                mTransKey.setWithoutSessionDecodeJson();
                // mTransKey.testAjax('mtranskey_pwd');
            }
        }
    },
    event: ()=>{
        //키보드
        $(`${rootId} .mTranceKey-btn`).on('click',function(){
            mTransKey.initSetting();
            mtk.onKeyboard($(`${rootId} #mtranskey_pwd`)[0]); //팝업
        })
        //입력 키보드 
        $(`${rootId} #mtranskey_pwd`).on('keydown',function(e){
            var value = $(e.currentTarget).val();
            if(mTransKey.isMasking(value)){
                mTransKey.clearInput();
            }
        })
    },
    clearInput: ()=>{
        $(`${rootId} #mtranskey_pwd`).val("");
        Provider.userInfo.mtranskeySsn2=null;
    },
    style_on: ()=>{
        $(`${rootId} .mTranceKey-btn`).removeClass("off"); 
        $(`${rootId} .mTranceKey-btn`).addClass("on"); 
    },
    style_off: ()=>{
        $(`${rootId} .mTranceKey-btn`).removeClass("on"); 
        $(`${rootId} .mTranceKey-btn`).addClass("off"); 
    },
    setmKey_position: ()=>{
        const top = $(`${rootId} #mtranskey_pwd`).offset().top + $(`${rootId} #mtranskey_pwd`).height();
        const left = $(`${rootId} #mtranskey_pwd`).offset().left - (max_width - $(`${rootId} #mtranskey_pwd`).width()-30)
        // mtk.now.div.style.top = top + "px";
        // mtk.now.div.style.left = left + "px";
        $(`${rootId} #mtranskey_pwd`).attr("data-tk-kbdxy",`${left} ${top}`);
        if(mtk != null && mtk.now != null){
            mtk.reSizeListener();
        }

    },
    setmtranskeySsn2:()=>{
        if(mtk != null && mtk.now != null){
            id = mtk.now.id
            var values = mtk.inputFillEncData(document.getElementById(id));
            var name = document.getElementById(id).name;
            var hidden = values.hidden;
            var hmac = values.hmac;
            var frmId = use_form_id ? "_"+document.getElementById("hidfrmId").value : "";
            
            const mtranskeySsn2 = {};
            mtranskeySsn2[`id`]=id;
            mtranskeySsn2[`name`]=name;
            mtranskeySsn2[`transkey`]=hidden;
            mtranskeySsn2[`transkey_HM`]=encodeURIComponent(hmac); 
            mtranskeySsn2[`transkeyUuid`]=mtk.transkeyUuid;
            mtranskeySsn2["hidfrmId"]=frmId;
            
            Provider.userInfo.mtranskeySsn2 = mtranskeySsn2;
            
            console.log(`mTransKey Request Json: ${JSON.stringify(mtranskeySsn2)}`);
        }
    },
    setWithoutSessionDecodeJson: ()=>{
        const mtranskeySsn2 = {};
        var id = "";
        var keyboardType = "";
        var keyIndex = "";
        var fieldType = "";
        var seedKey = $(`#oacxEmbededContents #seedKey`).val();
        var initTime = $(`#oacxEmbededContents #initTime`).val();
        var transkey_ExE2E = "";
        if(mtk != null && mtk.now != null){
            id = mtk.now.id
            keyboardType = mtk.now.keyboardType;
            keyIndex = mtk.now.keyIndex;
            fieldType = mtk.now.fieldType;
            transkey_ExE2E = mtk.now.ExE2E;
        }
        var values = mtk.inputFillEncData(document.getElementById(id));
        var hidden = values.hidden;
        var hmac = values.hmac;

        mtranskeySsn2[`id`]=id;
        mtranskeySsn2[`keyboardType`]=keyboardType;
        mtranskeySsn2[`keyIndex`]=keyIndex;
        mtranskeySsn2[`fieldType`]=fieldType;
        mtranskeySsn2[`seedKey`]=seedKey;
        mtranskeySsn2[`initTime`]=initTime;
        mtranskeySsn2[`transkey`]=hidden;
        mtranskeySsn2[`transkey_HM`]=encodeURIComponent(hmac);  //request.getParameter("transkey_HM_pwd1_frm"), 
        mtranskeySsn2[`transkey_ExE2E`]=transkey_ExE2E;

        Provider.userInfo.mtranskeySsn2 = mtranskeySsn2;

        console.log(`mTransKey Request Json: ${JSON.stringify(mtranskeySsn2)}`);
    },
    testAjax:()=>{
        if(mtk != null && mtk.now != null){
            var request = new XMLHttpRequest();

            const mtranskeySsn2 = Provider.userInfo.mtranskeySsn2;
            const keys = Object.keys(mtranskeySsn2);
            var params = "";
            keys.forEach(function(key){
                params += `${key}=${mtranskeySsn2[key]}&`;
            })

            request.open("POST", `${Config.url.jsp.contextPath}/oacx/mTranskey_test.jsp`, false);
            request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            request.setRequestHeader("Cache-Control", "no-cache");
            request.send(params);
            
            const result = request.responseText.replace(/\n/gi, '');
            console.log(`Result decode: ${result}
                mtranskeySsn2 = ${JSON.stringify(mtranskeySsn2)}
            `)
        }
    }
}
